// extracted by mini-css-extract-plugin
export default {"wrap":"Block_wrap__guhwR","title":"Block_title__Fgg31","titleLine":"Block_titleLine__faAwO"};